/**
 * Hero visual for the Calculator page. Renders the user-provided product
 * art (tablet + supporting cards + car) — keeps the same wrapper so the
 * rest of the page layout is untouched.
 */
const HERO_URL =
  "https://customer-assets.emergentagent.com/job_bill-of-sale-builder/artifacts/rq32jwq7_ChatGPT%20Image%2015%20may%202026%2C%2016_47_58.png";

export default function TabletMockup() {
  return (
    <div className="relative mx-auto w-full max-w-[640px]">
      <img
        src={HERO_URL}
        alt="CarSaleDoc private sale value calculator running on a tablet with market comparison, price history, value drivers and a bill of sale ready to sign"
        className="w-full h-auto rounded-2xl select-none"
        loading="eager"
        fetchpriority="high"
        draggable={false}
      />
    </div>
  );
}
